module.exports = __webpack_public_path__ + "img/songwriters-journal_B09MYVXM25.7814ebbf.jpg";